<template>
  <div>
    <nav>
      <v-dialog v-model="dialog" persistent max-width="450">
        <v-card>
          <v-card-title class="text-h6 text-center">
            ¿Desea guardar las preferencias?
          </v-card-title>
          <v-card-text>Para poder efectuar los cambios, es necesario cerrar sesión y
            volver a ingresar</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error" text @click="dialog = false"> Cancelar </v-btn>
            <v-btn color="primary" text @click="
              dialog = false;
            logout();
            ">
              Aceptar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Navbar -->
      <v-toolbar class="topbar" flat  dense>
        <v-app-bar-nav-icon app @click="drawer = !drawer" v-if="admin"></v-app-bar-nav-icon>
        <v-img v-if="!admin" @click="gotToHome()" src="../assets/logo_suim.png" max-width="100" class=""></v-img>
        <v-toolbar-title @click="gotToHome()" class="hand hidden-sm-and-down">
          {{ branchOffice }} | {{ fullName }} - {{ rol }}
        </v-toolbar-title>

        <v-spacer></v-spacer>

        <v-toolbar-items class="hidden-sm-and-down">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon @click="settings = !settings" v-bind="attrs" v-on="on">
                <v-icon color="dar-grey">mdi-cog</v-icon>
              </v-btn>
            </template>
            <span>Configuraciones</span>
          </v-tooltip>

          <v-menu offset-y :close-on-content-click="false" :nudge-width="240">
            <template v-slot:activator="{ on: menu, attrs }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on: tooltip }">
                  <v-btn plain v-bind="attrs" v-on="{ ...tooltip, ...menu }">
                    <v-icon> mdi-account </v-icon>
                  </v-btn>
                </template>
                <span>Perfil</span>
              </v-tooltip>
            </template>
            <v-list>
              <!-- <v-list-item>
                <v-list-item-title>
       
                
                </v-list-item-title>
              </v-list-item>
              <v-divider></v-divider> -->
              <v-list-item link @click="$router.push({ name: 'perfil' })">
                <v-list-item-icon>
                  <v-icon color="primary"> mdi-account-circle </v-icon>
                </v-list-item-icon>
                <v-list-item-title>   {{ fullName }}  </v-list-item-title>
              </v-list-item>

              <v-list-item link @click="logout">
                <v-list-item-icon>
                  <v-icon color="error"> mdi-logout </v-icon>
                </v-list-item-icon>
                <v-list-item-title> Cerrar sesión </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-toolbar-items>

        <v-menu class="hidden-md-and-up">
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon v-bind="attrs" v-on="on" class="hidden-md-and-up">
              <v-icon>mdi-dots-vertical</v-icon>
            </v-btn>
          </template>

          <v-list>
            <v-list-item>
              <v-list-item-content>
                <v-btn plain @click="$router.push({ name: 'perfil' })">
                  <v-icon color="primary" left> mdi-account-circle </v-icon>
                  Perfil
                </v-btn>
              </v-list-item-content>
            </v-list-item>

            <v-list-item>
              <v-list-item-content>
                <v-btn plain @click="settings = !settings">
                  <v-icon left>mdi-cog</v-icon> Preferencias
                </v-btn>
              </v-list-item-content>
            </v-list-item>

            <v-list-item>
              <v-list-item-content>
                <v-btn plain>
                  <v-icon color="primary" left>mdi-help</v-icon> Ayuda
                </v-btn>
              </v-list-item-content>
            </v-list-item>

            <v-list-item>
              <v-list-item-content>
                <v-btn plain @click="logout">
                  <v-icon color="red" left> mdi-logout</v-icon>
                  Cerrar sesión
                </v-btn>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-toolbar>

      <!-- Sidebar-setting -->
      <v-navigation-drawer app v-model="settings" temporary  hide-overlay right width="300">
        <v-toolbar flat>
          <v-toolbar-title> Configuración </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-icon icon @click="settings = !settings"> mdi-close</v-icon>
        </v-toolbar>

        <v-divider class="mb-3"></v-divider>

        <div class="container">
          <div class="mb-3 pl-1 text-subtitle-2 font-weight-black text--primary">
            Tema
          </div>

          <div class="mx-auto row row--dense">
            <v-btn-toggle tile group mandatory v-model="toggle_tema">
              <div class="col col-6">
                <v-btn text large @click="
                  enaBtn();
                $vuetify.theme.dark = false;
                ">
                  Claro
                  <v-icon right>mdi-white-balance-sunny</v-icon>
                </v-btn>
              </div>

              <div class="col col-6">
                <v-btn text large @click="
                  enaBtn();
                $vuetify.theme.dark = true;
                ">
                  Oscuro
                  <v-icon right>mdi-weather-night</v-icon>
                </v-btn>
              </div>
            </v-btn-toggle>
          </div>
        </div>

        <v-divider class="my-3"></v-divider>
<!-- 
        <div class="container">
          <div class="mb-3 pl-1 text-subtitle-2 font-weight-black text--primary">
            Modo
          </div>
          <div class="mx-auto row row--dense">
            <v-btn-toggle tile group mandatory v-model="toggle_modo">
              <div class="col col-6">
                <v-tooltip left>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn text large @click="enaBtn()" v-bind="attrs" v-on="on">
                      Admin<v-icon right>mdi-view-compact</v-icon>
                    </v-btn>
                  </template>
                  <span>
                    <div class="container text-center">
                      El <span class="font-weight-bold">modo ADMIN</span>,
                      desplegará un menu lateral, desde el cual podrá acceder a
                      cualquiera de los módulos y sus respectivas acciones
                    </div>
                  </span>
                </v-tooltip>
              </div>

              <div class="col col-6">
                <v-tooltip left>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn text large @click="enaBtn()" v-bind="attrs" v-on="on" disabled>
                      Standar<v-icon right>mdi-view-comfy</v-icon>
                    </v-btn>
                  </template>
                  <span>
                    <div class="container text-center">
                      El <span class="font-weight-bold">modo STANDAR</span>,
                      mantiene una vista con iconos, botónes y una interfaz más
                      intuitiva
                    </div>
                  </span>
                </v-tooltip>
              </div>
            </v-btn-toggle>
          </div>
        </div> -->

        <template v-slot:append>
          <div class="pa-2">
            <v-btn block class="primary" @click="savePreferences()" :disabled="vBtn">
              Guardar preferencias <v-icon right>mdi-cog-box</v-icon>
            </v-btn>
          </div>
          <!--LICENCIA-->
          <div class="row">
            <div class="col-md-12">
              <span class="r-4" v-if="status == '0'">
                <v-alert icon="mdi-shield-lock-outline" dense outlined type="error">
                  <v-spacer></v-spacer>

                  <strong> {{ licencia }}</strong>
                </v-alert>
              </span>
              <span class="r-" v-if="status == '1'">
                <v-alert icon="mdi-shield-lock-outline" dense outlined type="success">
                  <v-spacer></v-spacer>
                  <strong> {{ licencia }}</strong>
                </v-alert>
              </span>
            </div>
          </div>

          <div class="pa-5 text-center">
            <small>{{ $utilFront.VERSION }}</small>
            <!-- <hr class="mt-3 mb-3" style="border-top: 1.5px dashed green;"/>
            <small v-for="(change, index) in $utilFront.CHANGES" :key="index">
              {{index+1}}. {{ change }} <br/>
            </small> -->
          </div>
        </template>
      </v-navigation-drawer>

      <!-- Sidebar-admin -->
      <v-navigation-drawer app prominent dense disable-resize-watcher v-if="admin" class="sidebar nav-backfround" v-model="drawer"
        width="190">
        <v-list dense style="padding: 0px;">
          <v-list-item>
            <v-list-item-content>
              <v-img src="../assets/logo_suim.png" max-width="70" class="mx-auto"></v-img>
            </v-list-item-content>
            <v-list-item-title class="text-center hidden-md-and-up mt-3">
              {{ branchOffice }} | {{ fullName }} - {{ rol }}
            </v-list-item-title>
          </v-list-item>
        </v-list>

        <v-divider></v-divider>

        <v-list>
          
          <v-list-item router to="/recepcion" color="primary" link
            v-if="$utilFront.withPermission($prm.MODULE_RECEPTION)">
            <v-list-item-icon>
              <v-icon>mdi-bell</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title> Recepción </v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <!-- <v-list-item
            router
            to="/app/recepcion"
            color="primary"
            link
            v-if="$utilFront.withPermission($prm.MODULE_RECEPTION)"
          >
            <v-list-item-icon>
              <v-icon>mdi-bell</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title> Recepción Testeo</v-list-item-title>
            </v-list-item-content>
          </v-list-item> -->


          <v-list-item router to="/somatometria" color="primary" v-if="$utilFront.withPermission($prm.MODULE_DIARY)" link>
            <v-list-item-icon>
              <v-icon>mdi-book-edit</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title> Somatometría </v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-group prepend-icon="mdi-stethoscope" v-if="$utilFront.withPermission($prm.MODULE_CONSULTATION)">
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title>Consultas</v-list-item-title>
              </v-list-item-content>
            </template>

            <!-- <v-list-item
              router
              to="/consultas/interrogatorio"
              color="primary"
              link
              v-if="
                $utilFront.withPermission($prm.MODULE_VITAL_SIGNS) &&
                  $utilFront.nonLite()
              "
            >
              <v-list-item-content>
                <v-list-item-title> Signos vitales </v-list-item-title>
              </v-list-item-content>
            </v-list-item> -->

            <v-list-item router to="/consultas/pendientes" color="primary" link
              v-if="$utilFront.withPermission($prm.MODULE_CONSULTATION_PENDING)">
              <v-list-item-content>
                <v-list-item-title> Consultas pendientes </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item router to="/consultas/historial" color="primary" link
              v-if="$utilFront.withPermission($prm.MODULE_CONSULTATION_HISTORY)">
              <v-list-item-content>
                <v-list-item-title> Historial de consultas </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>

          <!-- <v-list-group
            prepend-icon="mdi-tooth"
            v-if="$utilFront.withPermission($prm.MODULE_DENTAL)"
          >
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title>Dental</v-list-item-title>
              </v-list-item-content>
            </template>

            <v-list-item
              router
              to="/dental/pendientes"
              color="primary"
              link
              v-if="$utilFront.withPermission($prm.MODULE_DENTAL_BEGIN)"
            >
              <v-list-item-content>
                <v-list-item-title> Consultas pendientes </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item
              router
              to="/dental/historial"
              color="primary"
              link
              v-if="$utilFront.withPermission($prm.MODULE_DENTAL_HISTORY)"
            >
              <v-list-item-content>
                <v-list-item-title> Historial de consultas </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group> -->

          <v-list-group prepend-icon="mdi-tooth" v-if="$utilFront.withPermission($prm.MODULE_DENTAL)">
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title>Dental</v-list-item-title>
              </v-list-item-content>
            </template>

            <v-list-item router to="/app/dental/pendientes" color="primary" link
              v-if="$utilFront.withPermission($prm.MODULE_DENTAL_BEGIN)">
              <v-list-item-content>
                <v-list-item-title> Consultas pendientes </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item router to="/app/dental/historial" color="primary" link
              v-if="$utilFront.withPermission($prm.MODULE_DENTAL_HISTORY)">
              <v-list-item-content>
                <v-list-item-title> Historial de consultas </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>

          <!-- /** 
          * @author Mau de Pallares 
          * @company Erillam Healthcare 
          * @version 2.0 
          */ -->
          <v-list-group prepend-icon="mdi-brain" v-if="$utilFront.withPermission($prm.MODULE_PSYCHOLOGY)">
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title>Psicología</v-list-item-title>
              </v-list-item-content>
            </template>

            <v-list-item router to="/app/psicologia/consultas-pendientes" color="primary" link
              v-if="$utilFront.withPermission($prm.MODULE_PSYCHOLOGY_ATTEND)">
              <v-list-item-content>
                <v-list-item-title> Consultas pendientes </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item router to="/app/psicologia/historial-consultas" color="primary" link
              v-if="$utilFront.withPermission($prm.MODULE_PSYCHOLOGY_HISTORIC)">
              <v-list-item-content>
                <v-list-item-title> Historial de consultas </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
          <v-list-group prepend-icon="mdi-eye" v-if="$utilFront.withPermission($prm.MODULE_OPTOMETRY)">
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title>Optometría</v-list-item-title>
              </v-list-item-content>
            </template>

            <v-list-item router :to="$routeConstants.OPTOMETRY_PENDING.path" color="primary" link
              v-if="$utilFront.withPermission($prm.MODULE_OPTOMETRY_PENDING)">
              <v-list-item-content>
                <v-list-item-title> Consultas pendientes </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item router :to="$routeConstants.OPTOMETRY_HISTORY.path" color="primary" link
              v-if="$utilFront.withPermission($prm.MODULE_OPTOMETRY_HISTORY)">
              <v-list-item-content>
                <v-list-item-title> Historial de consultas </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
          <v-list-group prepend-icon="mdi-ear-hearing" v-if="$utilFront.withPermission($prm.MODULE_AUDIOMETRY)">
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title>Audiometría</v-list-item-title>
              </v-list-item-content>
            </template>

            <v-list-item router :to="$routeConstants.AUDIOMETRY_PENDING.path" color="primary" link
              v-if="$utilFront.withPermission($prm.MODULE_AUDIOMETRY_PENDING)">
              <v-list-item-content>
                <v-list-item-title> Consultas pendientes </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item router :to="$routeConstants.AUDIOMETRY_HISTORY.path" color="primary" link
              v-if="$utilFront.withPermission($prm.MODULE_AUDIOMETRY_HISTORY)">
              <v-list-item-content>
                <v-list-item-title> Historial de consultas </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
          <!-- <v-list-group prepend-icon="mdi-crosshairs-gps" v-if="$utilFront.withPermission($prm.MODULE_COLPOSCOPY)">
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title>Colposcopia</v-list-item-title>
              </v-list-item-content>
            </template>

            <v-list-item router :to="$routeConstants.COLPOSCOPY_PENDING.path" color="primary" link
              v-if="$utilFront.withPermission($prm.MODULE_COLPOSCOPY_PENDING)">
              <v-list-item-content>
                <v-list-item-title> Pendientes </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item router :to="$routeConstants.COLPOSCOPY_HISTORY.path" color="primary" link
              v-if="$utilFront.withPermission($prm.MODULE_COLPOSCOPY_HISTORY)">
              <v-list-item-content>
                <v-list-item-title> Historial </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group> -->

          <v-list-group prepend-icon="mdi-monitor-dashboard" v-if="$utilFront.withPermission($prm.MODULE_TELEMEDICINE)">
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title>Telemedicina</v-list-item-title>
              </v-list-item-content>
            </template>

            <v-list-item router :to="$routeConstants.TELEMEDICINE_PENDING.path" color="primary" link
              v-if="$utilFront.withPermission($prm.MODULE_TELEMEDICINE_PAGINATION_PENDING)">
              <v-list-item-content>
                <v-list-item-title> Pendientes </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item router :to="$routeConstants.TELEMEDICINE_PAGINATION_START.path" color="primary" link
              v-if="$utilFront.withPermission($prm.MODULE_TELEMEDICINE_PAGINATION_START)">
              <v-list-item-content>
                <v-list-item-title> Por iniciar </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item router :to="$routeConstants.TELEMEDICINE_PAGINATION_HISTORY.path" color="primary" link
              v-if="$utilFront.withPermission($prm.MODULE_TELEMEDICINE_HISTORY)">
              <v-list-item-content>
                <v-list-item-title> Historial </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>

          <v-list-group prepend-icon="mdi-pill" v-if="$utilFront.withPermission($prm.MODULE_PHARMACY)">
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title>Farmacia</v-list-item-title>
              </v-list-item-content>
            </template>
            <v-list-item router to="/farmacia/pendientes" color="primary" link
              v-if="$utilFront.withPermission($prm.MODULE_PHARMACY_PENDING)">
              <v-list-item-content>
                <v-list-item-title>
                  Por dispensar
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item router to="/farmacia/historial" color="primary" link
              v-if="$utilFront.withPermission($prm.MODULE_PHARMACY_HISTORY)">
              <v-list-item-content>
                <v-list-item-title>
                  Historial de dispensaciones
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item router to="/farmacia/almacen" color="primary" link>
              <v-list-item-content>
                <v-list-item-title> Almacén </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item router to="/farmacia/merma" color="primary" link>
              <v-list-item-content>
                <v-list-item-title> Mermas </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>

          <v-list-group prepend-icon="mdi-microscope" v-if="$utilFront.withPermission($prm.MODULE_LABORATORY)">
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title>Laboratorio</v-list-item-title>
              </v-list-item-content>
            </template>
            <v-list-item :to="{ name: 'IniciarEstudio2', params: { speciality: 3 } }" color="primary" link
              v-if="$utilFront.withPermission($prm.MODULE_LABORATORY_BEGIN)">
              <v-list-item-content>
                <v-list-item-title>Por comenzar</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <!-- <v-list-item
              router
              to="/laboratorio/proceso"
              color="primary"
              link
              v-show="false"
            >
              <v-list-item-content>
                <v-list-item-title>Estudios en proceso</v-list-item-title>
              </v-list-item-content>
            </v-list-item> -->

            <v-list-item :to="{ name: 'CerrarEstudio2', params: { speciality: 3 } }" color="primary" link
              v-if="$utilFront.withPermission($prm.MODULE_LABORATORY_END)">
              <v-list-item-content>
                <v-list-item-title>Por validar</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item :to="{ name: 'HistorialEstudio2', params: { speciality: 3 } }" color="primary" link
              v-if="$utilFront.withPermission($prm.MODULE_LABORATORY_HISTORY)">
              <v-list-item-content>
                <v-list-item-title>Historial</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>

          <v-list-group prepend-icon="mdi-camera-iris" v-if="$utilFront.withPermission($prm.MODULE_IMAGE)">
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title>Imagen</v-list-item-title>
              </v-list-item-content>
            </template>
            <v-list-item :to="{ name: 'IniciarEstudio1', params: { speciality: 2 } }" color="primary" link
              v-if="$utilFront.withPermission($prm.MODULE_IMAGE_BEGIN)">
              <v-list-item-content>
                <v-list-item-title>Por comenzar</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <!-- <v-list-item
              router
              to="/imagen/proceso"
              color="primary"
              link
              v-show="false"
            >
           <v-list-item-icon>
              <v-icon>mdi-play</v-icon>
            </v-list-item-icon> 
              <v-list-item-content>
                <v-list-item-title>Estudios en proceso</v-list-item-title>
              </v-list-item-content>
            </v-list-item> -->

            <v-list-item :to="{ name: 'CerrarEstudio1', params: { speciality: 2 } }" color="primary" link
              v-if="$utilFront.withPermission($prm.MODULE_IMAGE_END)">
              <v-list-item-content>
                <v-list-item-title>Por cerrar</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item :to="{ name: 'HistorialEstudio1', params: { speciality: 2 } }" color="primary" link
              v-if="$utilFront.withPermission($prm.MODULE_IMAGE_HISTORY)">
              <v-list-item-content>
                <v-list-item-title>Historial</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
          <!-- <v-list-group
            prepend-icon="mdi-grease-pencil"
            v-if="$utilFront.withPermission($prm.MODULE_IMAGE_INTERPRETATION)"
          >
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title>Interpretación</v-list-item-title>
              </v-list-item-content>
            </template>
            <v-list-item
              :to="{
                name: 'InterpretationPendingView1',
                params: { speciality: 2 },
              }"
              color="primary"
              link
              v-if="
                $utilFront.withPermission(
                  $prm.MODULE_IMAGE_INTERPRETATION_PENDING
                )
              "
            >
              <v-list-item-content>
                <v-list-item-title>Interpretaciones pendientes</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item
              :to="{
                name: 'InterpretationHistoryView1',
                params: { speciality: 2 },
              }"
              color="primary"
              link
              v-if="
                $utilFront.withPermission(
                  $prm.MODULE_IMAGE_INTERPRETATION_HISTORY
                )
              "
            >
              <v-list-item-content>
                <v-list-item-title>Historial de interpretaciones</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group> -->
          <!-- INTEPRETATION WITH ROUTES -->
          <v-list-group prepend-icon="mdi-grease-pencil"
            v-if="$utilFront.withPermission($prm.MODULE_IMAGE_INTERPRETATION)">
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title>Interpretación</v-list-item-title>
              </v-list-item-content>
            </template>
            <v-list-item router to="/app/interpretacion/pendientes" color="primary" link v-if="$utilFront.withPermission(
              $prm.MODULE_IMAGE_INTERPRETATION_PENDING
            )
              ">
              <v-list-item-content>
                <v-list-item-title>Por interpretar</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item router to="/app/interpretacion/validar" color="primary" link v-if="$utilFront.withPermission(
              $prm.MODULE_INTERPRETATION_VALIDATE
            )
              ">
              <v-list-item-content>
                <v-list-item-title>Por validar</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item router to="/app/interpretacion/historial" color="primary" link v-if="$utilFront.withPermission(
              $prm.MODULE_IMAGE_INTERPRETATION_HISTORY
            )
              ">
              <v-list-item-content>
                <v-list-item-title>Historial</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
          <!--  -->
          <v-list-item router to="/historialClinico" color="primary" link
            v-if="$utilFront.withPermission($prm.MODULE_CLINIC_HISTORY)">
            <v-list-item-icon>
              <v-icon>mdi-folder</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title> Historia clínica </v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item router to="/app/medicos" color="primary" link v-if="$utilFront.withPermission($prm.MODULE_DOCTOR)">
            <v-list-item-icon>
              <v-icon>mdi-doctor</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title> Médicos </v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item router to="/usuarios" color="primary" link v-if="$utilFront.withPermission($prm.MODULE_USER)">
            <v-list-item-icon>
              <v-icon>mdi-account-multiple</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title> Usuarios </v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item router to="/localidad" color="primary" link v-if="$utilFront.withPermission($prm.MODULE_LOCATION)">
            <v-list-item-icon>
              <v-icon>mdi-map-marker</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title> Localidad </v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-group prepend-icon="mdi-repeat" v-if="$utilFront.withPermission($prm.MODULE_SYNCHRONIZATION)">
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title>Sincronización</v-list-item-title>
              </v-list-item-content>
            </template>
            <v-list-item router to="/app/sincronizacion/camujal" color="primary" link>
              <v-list-item-content>
                <v-list-item-title>Camujal</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>

          <v-list-group prepend-icon="mdi-file-chart" v-if="$utilFront.withPermission($prm.MODULE_REPORTS)">
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title>Reportes</v-list-item-title>
              </v-list-item-content>
            </template>
            <v-list-item router to="/reportes/reportadosDescartados" color="primary" link
              v-if="$utilFront.withPermission($prm.MODULE_REPORTS_DISCARTED)">
              <v-list-item-content>
                <v-list-item-title>Reportados y cancelados</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item router to="/reportes/interpretes" color="primary" link
              v-if="$utilFront.withPermission($prm.MODULE_REPORTS_INTERPRETERS)">
              <v-list-item-content>
                <v-list-item-title>Intérpretes</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item router to="/reportes/productividad" color="primary" link
              v-if="$utilFront.withPermission($prm.MODULE_REPORTS_PRODUCTIVITY)">
              <v-list-item-content>
                <v-list-item-title>Productividad</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item router to="/reportes/descarga/estudios" color="primary" link
              v-if="$utilFront.withPermission($prm.MODULE_DOWNLOAD_STUDIES)">
              <v-list-item-content>
                <v-list-item-title>Descarga de estudios</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item
              router
              to="/app/estudios/historico_estudios"
              color="primary"
              link
              v-if="$utilFront.withPermission($prm.STUDY_HISTORY_REPORT)"
            >
              <v-list-item-content>
                <v-list-item-title>Histórico estudios</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>

          <v-list-group prepend-icon="mdi-tune" v-if="$utilFront.withPermission($prm.MODULE_CONF)">
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title>Configuración</v-list-item-title>
              </v-list-item-content>
            </template>

            <!-- <v-list-item
              router
              to="/configuracion/permisos"
              color="primary"
              link
              v-show="false"
            >
              <v-list-item-content>
                <v-list-item-title>Permisos</v-list-item-title>
              </v-list-item-content>
            </v-list-item> -->

            <v-list-item router to="/configuracion/preferencias" color="primary" link
              v-if="$utilFront.withPermission($prm.MODULE_PACS)">
              <v-list-item-content>
                <v-list-item-title>Preferencias</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item router to="/configuracion/roles" color="primary" link
              v-if="$utilFront.withPermission($prm.MODULE_ROLES)">
              <v-list-item-content>
                <v-list-item-title>Roles y permisos</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <!-- <v-list-item
              router
              to="/configuracion/modulos"
              color="primary"
              link
              v-if="false"
            >
              <v-list-item-content>
                <v-list-item-title>Módulos</v-list-item-title>
              </v-list-item-content>
            </v-list-item> -->

            <v-list-item router to="/configuracion/sucursales" color="primary" link
              v-if="$utilFront.withPermission($prm.MODULE_BRANCH_OFFICE)">
              <v-list-item-content>
                <v-list-item-title>Sucursales</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <!-- Responsables de sucursal, pendiente todavía -->
            <!-- <v-list-item
              router
              to="/configuracion/responsables"
              color="primary"
              link
              
            >
              <v-list-item-content>
                <v-list-item-title>Responsables</v-list-item-title>
              </v-list-item-content>
            </v-list-item> -->
            <!-- <v-list-item
              router
              to="/reportes/sincronizacion"
              color="primary"
              link
              v-if="$utilFront.withPermission($prm.MODULE_REPORTS_INTERPRETERS)"
            >-->
            <!--<v-list-item
              router
              to="/configuracion/sincronizacion"
              color="primary"
              link
            >
              <v-list-item-content>
                <v-list-item-title>Sincronización</v-list-item-title>
              </v-list-item-content>
            </v-list-item>-->
            <v-list-item router to="/configuracion/especialidades" color="primary" link
              v-if="$utilFront.withPermission($prm.MODULE_SPECIALITY)">
              <v-list-item-content>
                <v-list-item-title>Especialidades</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item router to="/configuracion/modalidades" color="primary" link
              v-if="$utilFront.withPermission($prm.MODULE_MODALITY)">
              <v-list-item-content>
                <v-list-item-title>Modalidades</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item router to="/configuracion/perfiles" color="primary" link
              v-if="$utilFront.withPermission($prm.MODULE_STUDY_PROFILE)">
              <v-list-item-content>
                <v-list-item-title>Perfiles de estudio</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <!-- <v-list-item
              router
              to="/configuracion/consultorios"
              color="primary"
              link
              v-if="
                $utilFront.withPermission($prm.MODULE_CONSULTING_ROOM) &&
                  $utilFront.nonLite()
              "
            >
              <v-list-item-content>
                <v-list-item-title>Consultorios</v-list-item-title>
              </v-list-item-content>
            </v-list-item> -->
            <v-list-item router to="/configuracion/antecedentes" color="primary" link
              v-if="$utilFront.withPermission($prm.MODULE_BACKGROUND)">
              <v-list-item-content>
                <v-list-item-title>Antecedentes</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item router to="/configuracion/TipoPersonal" color="primary" link>
              <v-list-item-content>
                <v-list-item-title>Tipo de Personal</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item router to="/configuracion/laboratorio/categorias" color="primary" link>
              <v-list-item-content>
                <v-list-item-title>Categorías</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item router to="/configuracion/laboratorio/parametros" color="primary" link>
              <v-list-item-content>
                <v-list-item-title>Parámetros</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item router to="/configuracion/permisos" color="primary" link>
              <v-list-item-content>
                <v-list-item-title>Permisos</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item router to="/configuracion/dental/procedimientos" color="primary" link>
              <v-list-item-content>
                <v-list-item-title>Procedimientos Dentales</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item router to="/configuracion/signos_vitales" color="primary" link>
              <v-list-item-content>
                <v-list-item-title>Signos Vitales</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item router to="/configuracion/logos" color="primary" link>
              <v-list-item-content>
                <v-list-item-title>Logos</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item router to="/app/config/logs" color="primary" link>
              <v-list-item-content>
                <v-list-item-title>LOGS</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item router to="/app/config/sync" color="primary" link>
              <v-list-item-content>
                <v-list-item-title>Sincronización</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item router to="/app/config/hallazgos" color="primary" link>
              <v-list-item-content>
                <v-list-item-title>Hallazgos</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item router to="/app/config/servicios-web" color="primary" link
              v-if="$utilFront.withPermission($prm.MODULE_WEB_SERVICE)">
              <v-list-item-content>
                <v-list-item-title>Servicios web</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item router to="/app/config/productos" color="primary" link
              v-if="$utilFront.withPermission($prm.MODULE_WEB_SERVICE)">
              <v-list-item-content>
                <v-list-item-title>Productos</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item router to="/app/config/espacios-fisicos" color="primary" link
              v-if="$utilFront.withPermission($prm.MODULE_WEB_SERVICE)">
              <v-list-item-content>
                <v-list-item-title>Espacios físicos</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <!-- <v-list-item
              router
              to="/app/config/control-cambios"
              color="primary"
              link
            >
              <v-list-item-content>
                <v-list-item-title>Control de cambios</v-list-item-title>
              </v-list-item-content>
            </v-list-item> -->

          </v-list-group>
        </v-list>
      </v-navigation-drawer>
    </nav>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { UtilFront } from "@/core";
import { PacsConfigurationRequest } from "@/core/request";

export default {
  name: "Sidebar",
  data: () => ({
    dialog: false,
    drawer: true,
    vBtn: true,
    settings: false,
    viewMode: "",
    tema: false,
    toggle_tema: undefined,
    toggle_modo: undefined,
    admin: false,
    branchOffice: "",
    value: "recent",
    active: true,
    height: 80,
    licencia: null,
    status: null,
    icon: "mdi-chevron-up",
    rol: "ND",
    fullName: "",
    mini: true,
  }),
  computed: {
    ...mapState(["objPref"]),
  },
  mounted() {
    this.checkPreferences();
    this.vBtn = true;
    this.getUser();
  },
  methods: {
    ...mapActions(["logout", "sPreferences"]),
    showBottomNav() {
      if (this.height == 80) {
        this.height = 400;
        this.icon = "mdi-chevron-down";
      } else if (this.height == 400) {
        this.height = 80;
        this.icon = "mdi-chevron-up";
      }
    },
    getUser() {
      let user = {};
      user = UtilFront.getUser();
      this.branchOffice = user.person.branchOffice.name;
      this.rol = user.role.name;
      this.fullName = user.person.fullName;
    },
    getDateLincen() {
      // PacsConfigurationRequest.getLicense()
      //   .then((response) => {
      //     let { value, status } = response.data.data;
      //     this.licencia = value;
      //     this.status = status;
      //   })
      //   .catch((error) => {
      //     console.log(error);
      //   });
    },
    checkPreferences() {
      let objPref = [];

      let preferences = localStorage.getItem("preferencias");

      objPref = JSON.parse(preferences);

      if (objPref.theme) {
        this.toggle_tema = 1;
        this.$vuetify.theme.dark = true; // Modo Dark Activo
      } else {
        this.toggle_tema = 0;
        this.$vuetify.theme.dark = false; // Modo Dark Inactivo
      }

      if (objPref.view_type) {
        this.toggle_modo = 1; // Vista Admin
      } else {
        this.toggle_modo = 0; // Vista Standar
        this.admin = true;
      }
    },
    savePreferences() {
      let objPref = {};

      if (this.toggle_tema === 1) {
        objPref.theme = true;
      } else if (this.toggle_tema === 0) {
        objPref.theme = false;
      }

      if (this.toggle_modo === 1) {
        objPref.view_type = true;
      } else if (this.toggle_modo === 0) {
        objPref.view_type = false;
      }

      this.settings = false;

      this.vBtn = true;

      this.dialog = true;

      objPref = JSON.stringify(objPref);

      this.sPreferences(objPref);
    },
    enaBtn() {
      this.vBtn = false;
    },
    gotToHome() {
      // this.$router.push(
      //   UtilFront.isViewAdmin() ? { name: "Recepcion" } : { name: "Dashboard" }
      // );
      if (this.$utilFront.withPermission(PRM.MODULE_RECEPTION)) {
        // this.$router.replace("/recepcion");
        this.$router.push(
          UtilFront.isViewAdmin()
            ? { name: "Recepcion" }
            : { name: "Dashboard" }
        );
      } else if (this.$utilFront.withPermission(PRM.MODULE_DIARY)) {
        this.$router.push(
          UtilFront.isViewAdmin() ? { name: "Agenda" } : { name: "Dashboard" }
        );
      } else if (this.$utilFront.withPermission(PRM.MODULE_CONSULTATION)) {
        this.$router.push(
          UtilFront.isViewAdmin()
            ? { name: "Consultas" }
            : { name: "Dashboard" }
        );
      } else if (this.$utilFront.withPermission(PRM.MODULE_DENTAL)) {
        this.$router.push(
          UtilFront.isViewAdmin()
            ? { name: "ConsultaDental" }
            : { name: "Dashboard" }
        );
      } else if (this.$utilFront.withPermission(PRM.MODULE_PHARMACY)) {
        this.$router.push(
          UtilFront.isViewAdmin() ? { name: "Farmacia" } : { name: "Dashboard" }
        );
      } else if (this.$utilFront.withPermission(PRM.MODULE_LABORATORY)) {
        this.$router.push(
          UtilFront.isViewAdmin()
            ? { name: "IniciarEstudio2" }
            : { name: "Dashboard" }
        );
      } else if (this.$utilFront.withPermission(PRM.MODULE_IMAGE)) {
        this.$router.push(
          UtilFront.isViewAdmin()
            ? { name: "IniciarEstudio1" }
            : { name: "Dashboard" }
        );
      } else if (this.$utilFront.withPermission(PRM.MODULE_CLINIC_HISTORY)) {
        this.$router.push(
          UtilFront.isViewAdmin()
            ? { name: "HistoriaClinica" }
            : { name: "Dashboard" }
        );
      } else if (this.$utilFront.withPermission(PRM.MODULE_USER)) {
        this.$router.push(
          UtilFront.isViewAdmin() ? { name: "Usuarios" } : { name: "Dashboard" }
        );
      } else if (this.$utilFront.withPermission(PRM.MODULE_REPORTS)) {
        this.$router.push(
          UtilFront.isViewAdmin() ? { name: "Reportes" } : { name: "Dashboard" }
        );
      } else if (this.$utilFront.withPermission(PRM.MODULE_CONF)) {
        this.$router.push(
          UtilFront.isViewAdmin()
            ? { name: "PACSConfiguration" }
            : { name: "Dashboard" }
        );
      }
    },
  },
  created() {
    this.getDateLincen();
  },
};
</script>

<style scoped>
.topbar {
  border-bottom: 1px solid rgba(0, 0, 0, 0.06) !important;
}

.sidebar {
  border-right: 1px solid rgba(0, 0, 0, 0.06) !important;
}
</style>
